import { useMutation } from "@tanstack/react-query";
import { gqlReqNext } from "~utils/api/gql-req/next";
import {
	OpenManagedAccountSessionMutation,
	OpenManagedAccountSessionMutationVariables,
} from "~/types/__generated/gql/graphql";

const mutation = /* GraphQL */ `
	mutation OpenManagedAccountSession($accountId: ID!) {
		openManagedAccountSession(accountId: $accountId) {
			launchUrl
			expiresAt
			accountSlug
		}
	}
`;

export const useOpenManagedAccountSession = () =>
	useMutation({
		mutationFn: (accountId: string) =>
			gqlReqNext<
				OpenManagedAccountSessionMutation,
				OpenManagedAccountSessionMutationVariables
			>({
				query: mutation,
				variables: { accountId },
			}).then((res) => ({
				...res,
				launchUrl:
					process.env.NODE_ENV === "development"
						? res.launchUrl
								.replace("https://", "http://")
								.replace(process.env.ROUTER_DOMAIN_NAME!, "localhost:3000")
						: res.launchUrl,
			})),
	});
